// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__lU9m3","skillsCont":"Skills_skillsCont__0APra","icon":"Skills_icon__f+wPZ","iconList":"Skills_iconList__hrI2s"};